import {Button} from '@material-ui/core';
import React from 'react';
import Modal from 'Shared/components/Modal';
import './ExternalUploadQueueAdditionalDetailsModal.sass';

export type ExternalUploadQueueAdditionalDetailsModalProps = {
  onClose: () => void;
  reason: string;
  reasonType: string;
  returnComments: string;
};

const ExternalUploadQueueAdditionalDetailsModal = (props: ExternalUploadQueueAdditionalDetailsModalProps) => {
  const {onClose} = props;
  return (
    <Modal open onClose={onClose} title="Additional Details">
      <div className="additional-details-modal">
        <div className="additional-details-modal__details">
          <h6 className="title">{props.reasonType}</h6>
          <p>{props.reason !== '' && props.reason !== undefined ? props.reason : 'No details found'}</p>
        </div>
        {props.reasonType === 'Return to Broker Reason' ? (
          <div className="external-upload-return-modal__details">
            <h6 className="title">Comments</h6>
            <p> {props.returnComments}</p>
          </div>
        ) : null}

        <div className="modal__footer modal__footer-additional__details">
          <Button variant="contained" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ExternalUploadQueueAdditionalDetailsModal;
